//css-------------------
import '../../css/share/common.scss';
import '../../css/home/exhibit_content.scss';


//fontawesome
import( /* webpackPrefetch: true */ '../../lib/fontawesome/css/fontawesome.css');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/css/regular.css');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/css/brands.css');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/css/solid.css');

//js----------------------
//components
import( /* webpackPrefetch: true */ '../share/components/_common');
import( /* webpackPrefetch: true */ '../share/components/_lightbox');
import( /* webpackPrefetch: true */ '../share/components/_fontSize');


$(function () {

    $(document).keydown(function (e) {
        if (e.shiftKey && e.keyCode == 86) {
            document.getElementById('exhibit_viewer').querySelector('.openseadragon-canvas').focus();
        }
    });

    $('.social_btn_link.link').click(function () {
        prompt('複製連結', window.location.href);
        const el = document.createElement('textarea');
        el.innerHTML = window.location.href;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    });



    let _imgs = [];
    let _tileSources = [];
    let _id = $('#exhibit_viewer').data('id');
    const $exhibit_viewer_container = $('.exhibit_viewer_container');

    $.ajax({
        url: "/api/exhibit/" + _id,
        type: 'GET',
        success: function (data) {
            _imgs = data;
            _imgs.forEach((obj, ind) => {
                _tileSources.push('/storage/tiles/' + obj.tile + '/' + obj.tile + '.dzi');
                $exhibit_viewer_container.append('<span id="exhibit_viewer_label_' + ind + '" class="hide">' + obj.title + '</span>');
            });
            var viewer = OpenSeadragon({
                id: "exhibit_viewer",
                prefixUrl: "/img/toolbar/",
                showNavigator: true,
                sequenceMode: true,
                showReferenceStrip: true,
                tileSources: _tileSources,
            });

            viewer.addOnceHandler('open', function (e) {
                whenFullyLoaded(viewer.world.getItemAt(0), callback);
            });

            function whenFullyLoaded(tiledImage, callback) {
                if (tiledImage.getFullyLoaded()) {
                    setTimeout(callback, 1);
                } else {
                    tiledImage.addOnceHandler('fully-loaded-change', function () {
                        callback();
                    });
                }
            }

            function callback() {
                $('.referencestrip').attr('tabindex', '');
                $('.referencestrip').find('.openseadragon-canvas').each(function (i, o) {
                    $(o).attr('role', 'navigation');
                    $(o).attr('aria-labelledby', 'exhibit_viewer_label_' + i);
                });
            }
        },
        error: function (data) {
            console.log(data);
        }
    }).always(function (response, status) {
        console.log(response, status);
    });





    var item_detail_bar = $('.item_detail_bar');
    var item_detail = $('.item_detail');
    var angle = $('.item_detail_angle');
    var o = false;
    item_detail_bar.addClass('active');
    item_detail_bar.click(function () {
        if (o) {
            item_detail.slideDown();
            $(this).addClass('active');
            angle.addClass('active');
            o = false;
        } else {
            item_detail.slideUp();
            $(this).removeClass('active');
            angle.removeClass('active');
            o = true;
        }
    });
    item_detail_bar.keypress(function (e) {
        if (e.which == 13) {
            if (o) {
                item_detail.slideDown();
                $(this).addClass('active');
                angle.addClass('active');
                o = false;
            } else {
                item_detail.slideUp();
                $(this).removeClass('active');
                angle.removeClass('active');
                o = true;
            }
        }
    });
});